import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class SplashScreenComponent {
  // No lógica interna - solo template
  // Control desde app.component.ts con showSplash
}
